import getApi from '../../../../api'
import { ExternalServicesStatus } from '../../../../model/ExternalServices'

const baseUrl = '/external-services'

export const getServicesStatus = () => getApi().get<ExternalServicesStatus[]>(`${baseUrl}`)
